"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.trimStringProperties = exports.toTitleCase = exports.relatedFailedStateMatchHelper = exports.momentAtMidnight = exports.makeNameString = exports.isValidPatientRegForm = exports.isValidEHRName = exports.isValidEHRGender = exports.isValidEHRDOB = exports.isValidEHRAddress = exports.hidePatientRel = exports.hasAnyVideoPhoneAppt = exports.getVisitTypeTitle = exports.getStepIndex = exports.getPurposeOptionsByPatientRel = exports.getProviderLocationStateFullName = exports.getProviderImageUrl = exports.getProviderContactNumber = exports.getPhoneEhrPatientDemographics = exports.getNextStepId = exports.getMainContactNumber = exports.getApptSlotId = exports.getApptLocation = exports.formatProviderSecialties = exports.formatProviderName = exports.formatProviderDegrees = exports.formatLocation = exports.formatLastApptShownDate = exports.formatHeaderDate = exports.formatApptTime = exports.formatApiPhone = exports.formatApiDate = exports.buildPurposesSetFromResponses = exports.buildMapUrl = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _findIndex = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find-index"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _moment = _interopRequireDefault(require("moment"));
var _reactPhoneNumberInput = require("react-phone-number-input");
var _isPlainObject = _interopRequireDefault(require("lodash/isPlainObject"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _images = require("./constants/images");
var _VisitTypes = require("./constants/VisitTypes");
var _provider = require("./constants/provider");
var _Filters = require("./constants/Filters");
var _steps = _interopRequireDefault(require("./constants/steps"));
var _States = require("./constants/States");
var _providerStates = require("../lib/constants/providerStates");
var _Visibility = require("./constants/Visibility");
const formatProviderSecialties = function () {
  var _context;
  let specialties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (0, _map.default)(_context = (0, _filter.default)(specialties).call(specialties, v => !!v.specialty)).call(_context, v => v.specialty).join(', ');
};
exports.formatProviderSecialties = formatProviderSecialties;
const formatProviderDegrees = function () {
  var _context2;
  let degrees = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (0, _map.default)(_context2 = (0, _filter.default)(degrees).call(degrees, _ref => {
    let {
      name
    } = _ref;
    return !!name;
  })).call(_context2, _ref2 => {
    let {
      name
    } = _ref2;
    return name;
  }).join(',');
};
exports.formatProviderDegrees = formatProviderDegrees;
const formatProviderName = _ref3 => {
  var _context3;
  let {
    name,
    degrees
  } = _ref3;
  const formattedDegrees = formatProviderDegrees(degrees);
  // account for both v8 and v9 data while in transition (appt-cancel flow hits v8)
  // TODO: remove the fallback logic when both flows use search v9
  const fullName = name.full || name.full_name;
  return (0, _filter.default)(_context3 = [fullName, formattedDegrees ? ` ${formattedDegrees}` : null]).call(_context3, v => !!v).join();
};
exports.formatProviderName = formatProviderName;
const formatLocation = _ref4 => {
  var _context4;
  let {
    street1,
    street2,
    suite,
    city,
    state,
    zip
  } = _ref4;
  return (0, _filter.default)(_context4 = [street1, street2, suite, city, state, zip]).call(_context4, v => !!v).join(', ');
};
exports.formatLocation = formatLocation;
const insertOrConjunctionBeforeLastElem = (elem, i, array) => i != array.length - 1 ? elem : 'or ' + elem;
/**
 * Finds a provider's practice location
 * state (or territory) abbreviation, and returns the full name.
 * Use case: During pre-booking validation, a patient seeking a virtual visit
 * may be asked for telehealth attestation.
 *   - e.g., "Will you be in [[provider_state]] during the appointment?"
 *
 * @param {Object} provider
 * @returns {string} human-readable string composed of all full names of states (or territories), separated by commas and/or "or", or default to value of location.state
 */
const getProviderLocationStateFullName = _ref5 => {
  let {
    locations
  } = _ref5;
  /**`state` values here will be abbreviated names, e.g. "OH" for "Ohio" */
  const uniqueNames = [...new _set.default((0, _map.default)(locations).call(locations, _ref6 => {
    let {
      state
    } = _ref6;
    return state;
  }))];
  const names = (0, _map.default)(uniqueNames).call(uniqueNames, name => _providerStates.PROVIDER_STATES[name] ?? name);
  if (names.length < 2) return names.join();
  if (names.length == 2) return names.join(' or ');
  return (0, _map.default)(names).call(names, insertOrConjunctionBeforeLastElem).join(', ');
};

/**
 * Based on a provider and maybe* appointment, returns the correct contact number for that provider
 * If an appointment is passed in, we'll return the contact for that appointment slot location
 * @param {Object} provider
 * @param {Object} appointment
 * @returns {string}
 */
exports.getProviderLocationStateFullName = getProviderLocationStateFullName;
const getMainContactNumber = function (provider) {
  let appointment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (appointment) {
    return getApptLocation(provider, appointment).phone;
  }
  const providerPhone = getProviderContactNumber(provider);
  if (providerPhone) {
    return providerPhone;
  }
  return provider.locations[0] ? provider.locations[0].phone : '';
};

/**
 * Returns the contact number for a given provider
 * @param {Object} provider
 * @returns {String}
 */
exports.getMainContactNumber = getMainContactNumber;
const getProviderContactNumber = provider => {
  const {
    contacts = []
  } = provider;
  const {
    value
  } = (0, _find.default)(contacts).call(contacts, val => val.contact_type === 'phone') || {};
  return value;
};

/**
 *
 * @param {Object} provider
 * @param {Object} appointment
 * @returns {Object} provider location object that is related to the appointment
 */
exports.getProviderContactNumber = getProviderContactNumber;
const getApptLocation = (provider, appointment) => {
  var _context5;
  return (0, _find.default)(_context5 = provider.locations).call(_context5, location => {
    return location.id.toString() === appointment.location_id.toString();
  });
};

// Within an app, a mapApiKey wouldn't be passed down because we would already
// have googleMaps js loaded in the header.
// This accounts for usage within storybook
exports.getApptLocation = getApptLocation;
const buildMapUrl = apiKey => `https://maps.googleapis.com/maps/api/js?key=${apiKey}&amp;language=en&amp;region=US&amp;libraries=places`;

/**
 * ⚠️⚠️ This function is exported to be used outside of this package ⚠️⚠️
 * Given respones from the slots api for both established/new purposes, build an object
 * keyed by relationship type of Sets of appointment types
 * @param {} object containing `establishedPurposesResponse` and `newPurposesResponse`
 * @returns
 */
exports.buildMapUrl = buildMapUrl;
const buildPurposesSetFromResponses = _ref7 => {
  var _context6, _context7;
  let {
    establishedPurposesResponse,
    newPurposesResponse
  } = _ref7;
  return {
    [_Filters.ESTABLISHED_PATIENT]: new _set.default(establishedPurposesResponse.facets.length > 0 ? (0, _map.default)(_context6 = establishedPurposesResponse.facets[0].terms).call(_context6, term => term.value) : []),
    [_Filters.NEW_PATIENT]: new _set.default(newPurposesResponse.facets.length > 0 ? (0, _map.default)(_context7 = newPurposesResponse.facets[0].terms).call(_context7, term => term.value) : [])
  };
};

/**
 * Given a provider, return the provider image or a placeholder based on the
 * provider's gender
 * @param {Object} provider
 */
exports.buildPurposesSetFromResponses = buildPurposesSetFromResponses;
const getProviderImageUrl = provider => {
  const {
    image_url,
    gender
  } = provider || {};
  if (image_url) {
    return image_url;
  } else if (gender) {
    const lcGender = gender.toLowerCase();
    if (lcGender === 'male') {
      return _images.MALE_PROVIDER_AVATAR_URL;
    } else if (lcGender === 'female') {
      return _images.FEMALE_PROVIDER_AVATAR_URL;
    }
  }
  return _images.NEUTRAL_PROVIDER_AVATAR_URL;
};

/**
 * Given a provider, will return a list of purpose options by patientRel
 * @param {Object} provider
 * @returns {Object} {new: Set(), established: Set()}
 */
exports.getProviderImageUrl = getProviderImageUrl;
const getPurposeOptionsByPatientRel = function (provider) {
  let visibility = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Visibility.SCHEDULING_VISIBILITY_CONSUMER;
  const purposeByRel = {
    new: {},
    established: {}
  };
  const [visKey, visValue] = visibility.split(':');
  const ehrPurposes = provider.appointment_ehr_purposes || [];
  (0, _forEach.default)(ehrPurposes).call(ehrPurposes, _ref8 => {
    let {
      ehr_data,
      name,
      patient_relationship
    } = _ref8;
    const visiblePurpose = (0, _find.default)(ehr_data).call(ehr_data, _ref9 => {
      let {
        visibilities
      } = _ref9;
      return visibilities[visKey] === visValue;
    });
    if (visiblePurpose) {
      const {
        visit_method
      } = visiblePurpose;
      purposeByRel[patient_relationship][`${name}${visit_method}`] = {
        name,
        visit_method
      };
    }
  });
  const sortPurposes = purposeByRel => {
    var _context8;
    return (0, _sort.default)(_context8 = (0, _values.default)(purposeByRel)).call(_context8, (a, b) => a.name.localeCompare(b.name));
  };
  return {
    new: sortPurposes(purposeByRel.new),
    established: sortPurposes(purposeByRel.established)
  };
};

/**
 * Formats the given date to something expected by api
 * @param {Date | moment} date - anything usable by `moment` (date, string, momentDate)
 * @returns {string}
 */
exports.getPurposeOptionsByPatientRel = getPurposeOptionsByPatientRel;
const formatApiDate = date => (0, _moment.default)(date).format('YYYY-MM-DD HH:mm:00');

/**
 * Returns a date like the one passed in with the time portion set to midnight
 * @param {Date} date - anything parseable by the `moment` constructor: ie Date|String|another moment
 * @returns {Date} date adjusted to midnight
 */
exports.formatApiDate = formatApiDate;
const momentAtMidnight = date => {
  return (0, _moment.default)(date).startOf('day');
};

/**
 * Formats the given date to 'dddd, MMMM DD, YYYY'
 * @param {Date | moment} date - anything usable by `moment` (date, string, momentDate)
 * @returns {string}
 */
exports.momentAtMidnight = momentAtMidnight;
const formatHeaderDate = date => (0, _moment.default)(date).format('dddd, MMMM DD, YYYY');

/**
 * Formats the given date to 'h:mm A'
 * @param {Date | moment} date - anything usable by `moment` (date, string, momentDate)
 * @returns {string}
 */
exports.formatHeaderDate = formatHeaderDate;
const formatApptTime = date => (0, _moment.default)(date).format('h:mm A');

/**
 * Formats the given date to 'MMMM DD, YYYY'
 * @param {Date | moment} date - anything usable by `moment` (date, string, momentDate)
 * @returns {string}
 */
exports.formatApptTime = formatApptTime;
const formatLastApptShownDate = date => (0, _moment.default)(date).format('MMMM DD, YYYY');

/**
 * Concatenates first, middle, and last into a single name string
 * @param {string} first
 * @param {string} middle
 * @param {string} last
 * @returns {string} name (first middle last)
 */
exports.formatLastApptShownDate = formatLastApptShownDate;
const makeNameString = _ref10 => {
  let {
    first,
    middle,
    last
  } = _ref10;
  const name = [];
  if (first) name.push(first);
  if (middle) name.push(middle);
  if (last) name.push(last);
  return name.join(' ');
};

/**
 * Shallowly trim string properties within a plain object. Properties that are not strings are not mutated.
 * @param {object} plainObj An object containing string properties (e.g. { first: "  Dwayne  ", middle: " (The Rock) ", last: " Johnson    " })
 * @returns {object} Trimmed string properties (e.g. { first: "Dwayne", middle: "(The Rock)", last: "Johnson" })
 */
exports.makeNameString = makeNameString;
const trimStringProperties = plainObj => {
  var _context9;
  if (plainObj == null || (0, _isPlainObject.default)(plainObj) === false) return plainObj;
  const newPlainObj = {};
  (0, _forEach.default)(_context9 = (0, _keys.default)(plainObj)).call(_context9, key => {
    const value = plainObj[key];
    const type = typeof value;
    if (type === 'string') {
      newPlainObj[key] = (0, _trim.default)(value).call(value);
    } else {
      newPlainObj[key] = value;
    }
  });
  return newPlainObj;
};

/**
 * Capitalizes a proper noun or phrase, first letter capital with the
 * rest lowercased for each word, with special handling for names with
 * special characters such as hyphens and apostrophes
 * @param {string} word
 */
exports.trimStringProperties = trimStringProperties;
const toTitleCase = word => {
  if (typeof word !== 'string') {
    return '';
  }
  if (word.length <= 1) {
    return word.toUpperCase();
  }

  /**
   * If a special character is encountered, both left/right
   * sides of the special character will be title-cased independently
   * for examples
   * o'neil => O'Neil
   * the bird => The Bird
   * john-paul => John-Paul
   */
  const splitOnCharacters = ["'", '’', ' ', '-', '–'];
  for (let i = 0; i < splitOnCharacters.length; i++) {
    const char = splitOnCharacters[i];
    if ((0, _indexOf.default)(word).call(word, char) > -1) {
      var _context10;
      // break up the string into substrings, recursively call toTitleCase
      // on each and THEN join the results
      return (0, _map.default)(_context10 = word.split(char)).call(_context10, toTitleCase).join(char);
    }
  }
  return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
};

/**
 * Returns an E.164 formatted phone number
 * @param {string?} phoneNumber phone number
 * @returns {string} E.164 formatted phone number
 */
exports.toTitleCase = toTitleCase;
const formatPhoneNumberAsE164 = function () {
  let phoneNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  // Remove any & all hyphens from phone number
  const strNum = phoneNumber.replace(/-/g, '');
  // if number is locally formatted (without location code),
  // should add location code +1 for US/CA
  const shouldAddLocationCode = (0, _indexOf.default)(strNum).call(strNum, '+') !== 0 && strNum.length === 10;
  return shouldAddLocationCode ? `+1${strNum}` : strNum;
};

/**
 * Returns an object with:
 * - a E.164 formatted phone number (required because the phone-number input operates on phone numbers in E.164 format) and
 * - a phone type
 * 1. If defaultPhoneType exists, the returned object's type will be the defaultPhoneType and we'll try
 *    to find a corresponding number from the EhrPatientDemographics' phones (otherwise empty string)
 * 2. If defaultPhoneType does not exist, we'll check if a phone with mobile type exists and return it
 * 3. Otherwise, we'll return an object with the first phone's number. Not returning type here b/c when
 *    the provided type (e.g. type: "unknown") does not exist in CS config's type options array, forms-v2
 *    preselects the first type from config which is inaccurate
 * @param {array} phones an array of phones objects in the shape { type, number }
 * @param {Object} phoneConfig customer service forms-v2 config for the phone field
 * @returns {Object} {type?: string, number: string}
 */
const getPhoneEhrPatientDemographics = function () {
  let phones = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let phoneConfig = arguments.length > 1 ? arguments[1] : undefined;
  const defaultPhoneType = phoneConfig?.subFields?.type?.defaultValue;
  if (defaultPhoneType) {
    const phone = (0, _find.default)(phones).call(phones, phone => phone.type === defaultPhoneType) || {};
    const number = phone.number || '';
    return {
      type: defaultPhoneType,
      number: formatPhoneNumberAsE164(number)
    };
  }
  const mobilePhone = (0, _find.default)(phones).call(phones, phone => phone.type === 'mobile') || {};
  if (!(0, _isEmpty.default)(mobilePhone)) {
    const number = mobilePhone.number || '';
    return {
      type: 'mobile',
      number: formatPhoneNumberAsE164(number)
    };
  }
  return {
    number: formatPhoneNumberAsE164(phones[0]?.number)
  };
};

/**
 * Returns a phone number formatted for the API, which is a local
 * number without country code or formatting
 * @param {string} phoneNumber phone number in E.164 format
 * @returns {string} phoneNumber formatted locally, integers only
 */
exports.getPhoneEhrPatientDemographics = getPhoneEhrPatientDemographics;
const formatApiPhone = phoneNumber => {
  const parsed = (0, _reactPhoneNumberInput.parsePhoneNumber)(phoneNumber);
  if (parsed) {
    // if phone parsed as valid, return its local version
    return parsed.nationalNumber;
  }
  // if phone was invalid, return what came in stripped of formatting
  return (phoneNumber || '').replace(/\D*/g, '');
};
exports.formatApiPhone = formatApiPhone;
const hasAnyVideoPhoneAppt = query => {
  var _context11;
  return (0, _includes.default)(_context11 = [_VisitTypes.PHONE, _VisitTypes.VIDEO]).call(_context11, query);
};
exports.hasAnyVideoPhoneAppt = hasAnyVideoPhoneAppt;
const getApptSlotId = appointment => {
  return `slot-${appointment.location_id.toString()}-${appointment.start_datetime.replace(/\s+/g, '')}`;
};
exports.getApptSlotId = getApptSlotId;
const getVisitTypeTitle = type => {
  const placeholder = {
    [_VisitTypes.PHONE]: 'appointmentPhoneTitle',
    [_VisitTypes.VIDEO]: 'appointmentVideoTitle',
    [_VisitTypes.IN_PERSON]: 'appointmentInPersonTitle'
  };
  return placeholder[type];
};

/**
 * Determines whether or not we should hide the patient relationship question on the ApptInfo
 * step in the flow based on the provider.entity_type and a config flag (hide_patient_rel_for_locations)
 * @param {object} provider a provider or bookable entity (e.g. location/clinic)
 * @param {boolean} hidePatientRelForLocations config flag; true means hide the patient rel question
 * @param returns true if we should hide the patient rel question, else false
 */
exports.getVisitTypeTitle = getVisitTypeTitle;
const hidePatientRel = (provider, hidePatientRelForLocations) => {
  if (provider[_provider.ENTITY_TYPE] && provider[_provider.ENTITY_TYPE] === _provider.LOCATION_ENTITY_TYPE && hidePatientRelForLocations === true) {
    return true;
  } else {
    return false;
  }
};

/**
 * Get numeric index that the given stepId has in the given stepsConfigId
 * @param {string} stepsConfigId see lib/constants/steps for config ids
 * @param {*} stepId Step ID from constants/states
 * @return {number} index of the step, or -1 if the step is not in the steps config
 */
exports.hidePatientRel = hidePatientRel;
const getStepIndex = (stepsConfigId, stepId) => {
  const steps = _steps.default[stepsConfigId];
  return (0, _findIndex.default)(steps).call(steps, step => step.stateKey === stepId);
};

/**
 * Get the step id of the step immediately following the provided step id.
 * @param {string} stepsConfigId see lib/constants/steps for config ids
 * @param {*} curStepId constants/states value for the 'current state'
 * @return {?number} stepId of the next step, or null if there is no next step
 */
exports.getStepIndex = getStepIndex;
const getNextStepId = (stepsConfigId, curStepId) => {
  const steps = _steps.default[stepsConfigId];
  const currentStepIndex = getStepIndex(stepsConfigId, curStepId);
  if (steps[currentStepIndex + 1]) {
    return steps[currentStepIndex + 1].stateKey;
  }
  return null;
};

/**
 * Helper function to determine whether a patient name is valid for EHR purposes.
 * Use idealized requirements of first and last being present and non-whitespace.
 * @param {Object} name An object representing a name, with properties for first, last, middle, etc.
 */
exports.getNextStepId = getNextStepId;
const isValidEHRName = function () {
  var _context12, _context13, _context14, _context15;
  let name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    first: '',
    last: ''
  };
  const firstValid = !!((_context12 = name?.first) == null ? void 0 : (0, _bind.default)(_context13 = Function.call).call(_context13, (0, _trim.default)(_context12), _context12))?.();
  const lastValid = !!((_context14 = name?.last) == null ? void 0 : (0, _bind.default)(_context15 = Function.call).call(_context15, (0, _trim.default)(_context14), _context14))?.();
  return firstValid && lastValid;
};

/**
 * Helper function to determine whether a patient dob is valid for EHR purposes.
 * Use idealized requirements of just being present and non-whitespace.
 * @param {string} dob A string representing a date of birth.
 */
exports.isValidEHRName = isValidEHRName;
const isValidEHRDOB = function () {
  var _context16, _context17;
  let dob = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return dob && !!((_context16 = dob) == null ? void 0 : (0, _bind.default)(_context17 = Function.call).call(_context17, (0, _trim.default)(_context16), _context16))?.();
};

/**
 * Helper function to determine whether a patient gender is valid for EHR purposes.
 * Use idealized requirements of just being present and non-whitespace.
 * @param {string} gender A string representing a gender.
 */
exports.isValidEHRDOB = isValidEHRDOB;
const isValidEHRGender = function () {
  var _context18, _context19;
  let gender = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return gender && !!((_context18 = gender) == null ? void 0 : (0, _bind.default)(_context19 = Function.call).call(_context19, (0, _trim.default)(_context18), _context18))?.();
};

/**
 * Helper function to determine whether a patient address is valid for EHR purposes.
 * Use idealized requirements of city, state, street1, and zip just being present and non-whitespace.
 * @param {Object} address An object representing an address, with properties for city, state, street1, street2, zip, etc.
 */
exports.isValidEHRGender = isValidEHRGender;
const isValidEHRAddress = function () {
  var _context20, _context21, _context22, _context23, _context24, _context25, _context26, _context27;
  let address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    city: '',
    state: '',
    street1: '',
    zip: ''
  };
  const cityValid = !!((_context20 = address?.city) == null ? void 0 : (0, _bind.default)(_context21 = Function.call).call(_context21, (0, _trim.default)(_context20), _context20))?.();
  const stateValid = !!((_context22 = address?.state) == null ? void 0 : (0, _bind.default)(_context23 = Function.call).call(_context23, (0, _trim.default)(_context22), _context22))?.();
  const street1Valid = !!((_context24 = address?.street1) == null ? void 0 : (0, _bind.default)(_context25 = Function.call).call(_context25, (0, _trim.default)(_context24), _context24))?.();
  const zipValid = !!((_context26 = address?.zip) == null ? void 0 : (0, _bind.default)(_context27 = Function.call).call(_context27, (0, _trim.default)(_context26), _context26))?.();
  return cityValid && stateValid && street1Valid && zipValid;
};

/*
 * Helper function to determine when the state machine is in one of the "related patient failure"
 * states (`ehrRelatedFailed` or `ehrSomebodyElseFormRelatedFailed`)
 *
 * @param state xstate state object
 * @returns boolean Whether the state machine is in a ehr related patient failure context
 */
exports.isValidEHRAddress = isValidEHRAddress;
const relatedFailedStateMatchHelper = state => {
  var _context28, _context29;
  return state && ((0, _includes.default)(_context28 = (0, _values.default)(state.value)).call(_context28, _States.ehrFormRelatedFailed) || (0, _includes.default)(_context29 = (0, _values.default)(state.value)).call(_context29, _States.ehrSomebodyElseFormRelatedFailed));
};

/**
 * Util function that determines if the given object is a valid patient reg form
 * config. Doesn't do deep analysis, simply checks for a non-empty object.
 *
 * @param {Object} patientRegForm
 * @returns Boolean
 */
exports.relatedFailedStateMatchHelper = relatedFailedStateMatchHelper;
const isValidPatientRegForm = patientRegForm => {
  return patientRegForm && typeof patientRegForm === 'object' && !(0, _isArray.default)(patientRegForm) && (0, _keys.default)(patientRegForm).length > 0;
};
exports.isValidPatientRegForm = isValidPatientRegForm;